import { render, staticRenderFns } from "./GeneralSettingDeliveryBlackoutsDates.vue?vue&type=template&id=06d6687a&"
import script from "./GeneralSettingDeliveryBlackoutsDates.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingDeliveryBlackoutsDates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports